<div
  class="shadow-widget-url-popup-container"
  (click)="block($event)"
>
  <div class="top">
    <span class="header">{{ title }}</span>
    <mat-icon
      svgIcon="info"
      matTooltip="You can share this link with anyone who has shadow login access to view this page."
      matTooltipShowDelay="225"
    ></mat-icon>
  </div>

  <div class="bottom">
    <mat-form-field
      class="link-field"
      appearance="outline"
      color="accent"
    >
      <input
        class="link-input"
        matInput
        [ngModel]="url"
        readonly
      />
    </mat-form-field>
    <button
      class="copy-btn"
      mat-flat-button
      color="accent"
      (click)="onCopyClick($event)"
    >
      Copy
    </button>
  </div>
</div>
